// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1eVzi","footer":"ModalCreateQualiphyProcedure_footer__TGgjm","additionData":"ModalCreateQualiphyProcedure_additionData__1hGao"};